// extracted by mini-css-extract-plugin
export default {"loader":"AdList_loader__gjm9g","spinner":"AdList_spinner__Oqdhh","templateListCollapse":"AdList_templateListCollapse__BQMmE","container":"AdList_container__xp67n"};